import { render, staticRenderFns } from "./AddJobFamilyDialog.vue?vue&type=template&id=6fbc3712&scoped=true"
import script from "./AddJobFamilyDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AddJobFamilyDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AddJobFamilyDialog.vue?vue&type=style&index=0&id=6fbc3712&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbc3712",
  null
  
)

export default component.exports